import { useSelector } from 'react-redux';
import { isRootAlbumStorage } from 'reactApp/modules/albums/albums.selector';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';

export const useShowBackItem = (): boolean => {
    const isSelectingMode = useSelector(SelectionsSelectors.isAnyIndexSelected);
    const isAlbumRoot = useSelector(isRootAlbumStorage);

    return isSelectingMode && !isAlbumRoot;
}